import React, { createContext, useContext, useMemo } from 'react';
import { usePageVisibility } from '@/hooks/app/usePageVisibility';

interface ChatVisibilityContextValue {
  isPageActive: boolean;
  isVisible: boolean;
  isFocused: boolean;
}

const ChatVisibilityContext = createContext<ChatVisibilityContextValue | null>(null);

export const ChatVisibilityProvider = ({ children }: { children: React.ReactNode }) => {
  const { isVisible, isFocused, isPageActive } = usePageVisibility();

  const value = useMemo(() => ({
    isPageActive,
    isVisible,
    isFocused
  }), [isPageActive, isVisible, isFocused]);

  return (
    <ChatVisibilityContext.Provider value={value}>
      {children}
    </ChatVisibilityContext.Provider>
  );
};

export const useChatVisibility = () => {
  const ctx = useContext(ChatVisibilityContext);
  if (!ctx) {
    throw new Error('useChatVisibility must be used within ChatVisibilityProvider');
  }
  return ctx;
};
